import type { FinanceAreaKey } from '@/components/Financeiro/solicitacoes/financeSolicitacoesConfig'
import {
  Briefcase,
  Building2,
  CircleEllipsis,
  FileText,
  Landmark,
  type LucideIcon,
} from 'lucide-react'

export const PORTAL_AREA_ICONS: Record<FinanceAreaKey, LucideIcon> = {
  PJ: Briefcase,
  GESTAO: Building2,
  COMERCIAL: Landmark,
  PROCESSOS: FileText,
  OUTROS: CircleEllipsis,
}

export const portalModalOverlay =
  'fixed inset-0 z-50 flex items-end justify-center bg-slate-900/45 p-0 backdrop-blur-[6px] sm:items-center sm:p-4'

export const portalModalShell =
  'flex max-h-[min(92vh,760px)] w-full flex-col overflow-hidden rounded-t-2xl border border-border/60 bg-bg-primary shadow-2xl sm:max-w-xl sm:rounded-2xl'

export const portalModalHeader =
  'relative shrink-0 border-b border-border/70 bg-gradient-to-br from-accent/[0.09] via-bg-primary to-bg-primary px-5 py-5 sm:px-6'

export const portalCardBase =
  'group relative overflow-hidden rounded-2xl border border-border/80 bg-bg-primary p-5 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-accent/45 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/35'

export function portalUserInitials(name?: string | null) {
  if (!name?.trim()) return 'PJ'
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0] ?? ''}${parts[parts.length - 1][0] ?? ''}`.toUpperCase()
}
